module.exports = __webpack_public_path__ + "img/矩形 2939.81b7bfb2.png";